import axios from "axios"
import library from "../../../utils/Library"

export const updateSubscriberCorpEntities = async (subscriberId, body) => {
  const TOKEN = sessionStorage.getItem("token")
  const URL = `${library.getBaseAPIUrl(
    "subscribers",
  )}/updateSubscriberCorpEntities/${subscriberId}`

  return await axios({
    url: URL,
    method: "PUT",
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
    data: body,
  })
}
